// document.addEventListener("DOMContentLoaded", function () {
//     if (window.location.href.includes("urbanmonkey.com/pages/loop2-waitlist")) {
//         const loader = document.getElementById("loader");
//         const targetSelector = ".webengage-webp13-container";

//         if (loader) loader.style.display = "block";

//         let checkInterval = setInterval(() => {
//             const targetElement = document.querySelector(targetSelector);
//             if (targetElement) {
//                 if (loader) loader.style.display = "none";
//                 clearInterval(checkInterval);
//             }
//         }, 200);

//         // Fallback: Hide loader after 5 seconds even if element isn't found
//         setTimeout(() => {
//             if (loader) loader.style.display = "none";
//             clearInterval(checkInterval);
//         }, 4000);
//     }
// });


function Waitlist(event, eventName) {
  event.preventDefault();
  
  const emailInput = document.getElementById('email').value.trim();
  let mobileNumberInput = document.getElementById('mobileNumber').value.trim();
  const successMessage = document.querySelector('.success-message span');
  const Paragraph = document.querySelector('#paragraph');
  const successText = document.querySelector('#success-message');
  const form = document.querySelector(".signup-form--wrapper form");
  let phoneError = document.querySelector("#phoneError");
  let emailError = document.querySelector("#emailError");

  mobileNumberInput = mobileNumberInput.replace(/\D/g, "");

  // Mobile number validation
  const phonePattern = /^\d{10,15}$/;
  // const mobileNumberIsValid = mobileNumberInput && /^\d{10}$/.test(mobileNumberInput);
  const mobileNumberInputTrimmed = mobileNumberInput.trim();
  console.log(mobileNumberInputTrimmed);
  const mobileNumberIsValid = /^[0-9]{10}$/.test(mobileNumberInputTrimmed);

  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (emailPattern.test(emailInput)) {
    emailError.innerText = '';
    
    if (mobileNumberIsValid) {
      phoneError.innerText = '';

      const userDetails = {
        email: emailInput,
        mobileNumber: mobileNumberInput
      };
      
      let form = event.target.closest("form");
      let sheetURL;

    if (form.id === "systms-waitlist-form") {
      sheetURL = "https://script.google.com/macros/s/AKfycby1Rx_4-rnNqUUHmiuUse49W_ywJfX9a9rZ6r-y2A1w587-wljwYwtPFKZa1TLkZ6JC/exec";
    } else if (form.id === "loops-waitlist-form") {
      sheetURL = "https://script.google.com/macros/s/AKfycby1Rx_4-rnNqUUHmiuUse49W_ywJfX9a9rZ6r-y2A1w587-wljwYwtPFKZa1TLkZ6JC/exec";
    } else {
      console.error("Form ID not recognized.");
      return;
    }

      let datas = new FormData(form);

      // The FormData() method creates a new FormData object that contains the values of all the form fields.
      fetch(sheetURL, {
        method: "POST",
        body: datas
      })
      .then(res => res.text())
      .then(data => {
        // Handle response data
      });

      // Call WebEngage's track function
      webengageOnReady(function() {
        webengage.track(eventName, userDetails);
        Paragraph?.classList.add('hide');
        successText.innerText = 'Thanks for joining the Waitlist! We will email you shortly.';
        form.classList.add('hide');
      });

    } else {
      phoneError.innerText = "PLEASE ENTER THE CORRECT PHONE NUMBER";
    }

  } else {
    emailError.innerText = "PLEASE ENTER THE CORRECT EMAIL ADDRESS";
  }
}
function loopWaitlist(event, eventName) {
  event.preventDefault();

  const emailInput = document.getElementById('email').value.trim();
  const successMessage = document.querySelector('.success-message span');
  const Paragraph = document.querySelector('#paragraph');
  const successText = document.querySelector('#success-message');
  const form = event.target.closest("form");
  let emailError = document.querySelector("#emailError");

  // Email validation
  const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  if (emailPattern.test(emailInput)) {
    emailError.innerText = '';

    const userDetails = { email: emailInput };

    let sheetURL;

    if (form.id === "systms-waitlist-form") {
      sheetURL = "https://script.google.com/macros/s/AKfycby1Rx_4-rnNqUUHmiuUse49W_ywJfX9a9rZ6r-y2A1w587-wljwYwtPFKZa1TLkZ6JC/exec";
    } else if (form.id === "loops-waitlist-form") {
      sheetURL = "https://script.google.com/macros/s/AKfycby1Rx_4-rnNqUUHmiuUse49W_ywJfX9a9rZ6r-y2A1w587-wljwYwtPFKZa1TLkZ6JC/exec";
    } else {
      console.error("Form ID not recognized.");
      return;
    }

    let datas = new FormData(form);

    fetch(sheetURL, {
      method: "POST",
      mode: "no-cors",
      body: datas
    })
    .then(res => res.text())
    .then(data => {
      // Handle response data
    });

    // Call WebEngage's track function
    webengageOnReady(function() {
      webengage.track(eventName, userDetails);
      Paragraph?.classList.add('hide');
      // successText.innerText = 'THANK YOU! YOU’RE ON THE WAITLIST. WE WILL EMAIL YOU DROP DETAILS SOON.';
      let successImg = document.querySelector(".t4s-banner-content .t4s-img-child");
      successImg.classList.remove('hide-element');
      form.classList.add('hide');
    });

  } else {
    emailError.innerText = "PLEASE ENTER THE CORRECT EMAIL ADDRESS";
    emailError.classList.remove('hide');
  }
}
